import Vue from 'vue';

const state = {
  mobileAddToBookshelfState: false,
  mobileMenuDisplayState: false,
  mobileSearchDisplayState: false,
  notificationsPanelDisplayState: false,
};

const getters = {
  'get-mobile-add-to-bookshelf-state': (state) => state.mobileAddToBookshelfState,
  'get-mobile-menu-display-state': (state) => state.mobileMenuDisplayState,
  'get-mobile-search-display-state': (state) => state.mobileSearchDisplayState,
  'get-notifications-panel-display-state': (state) => state.notificationsPanelDisplayState,
};

const actions = {
  closeMobileAddToBookshelf({ commit }) {
    commit('saveMobileAddToBookshelfOpenState', false);
  },

  closeMobileMenu({ commit }) {
    commit('saveMobileMenuOpenState', false);
  },

  closeMobileSearch({ commit }) {
    commit('saveMobileSearchOpenState', false);
  },

  closeNotificationsPanel({ commit }) {
    commit('saveNotificationsPanelOpenState', false);
  },

  openMobileAddToBookshelf({ commit }) {
    commit('saveMobileAddToBookshelfOpenState', true);
  },

  openMobileMenu({ commit }) {
    commit('saveMobileMenuOpenState', true);
  },

  openMobileSearch({ commit }) {
    commit('saveMobileSearchOpenState', true);
  },

  openNotificationsPanel({ commit }) {
    commit('saveNotificationsPanelOpenState', true);
  },
};

const mutations = {
  saveMobileAddToBookshelfOpenState(state, openState) {
    Vue.set(state, 'mobileAddToBookshelfState', openState);
  },

  saveMobileMenuOpenState(state, openState) {
    Vue.set(state, 'mobileMenuDisplayState', openState);
  },

  saveMobileSearchOpenState(state, openState) {
    Vue.set(state, 'mobileSearchDisplayState', openState);
  },

  saveNotificationsPanelOpenState(state, openState) {
    Vue.set(state, 'notificationsPanelDisplayState', openState);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
